import { styled } from '@mui/material';

export const ExtraBold = styled('span')(() => ({
  fontWeight: 900,
}));
